<form [formGroup]="filterForm()" class="flex flex-col gap-lg">
  <!-- Resource Type Row -->
  <div class="flex items-center gap-lg">
    <lib-drag-dots-icon
      [width]="'20'"
      [height]="'20'"
      [fill]="'#6B7280'"
      [iconClass]="'flex-shrink-0 cursor-move size-5'" />
    <label
      class="text-base font-medium text-neutral-700 border border-neutral-300 rounded-md px-md py-sm h-[2.75rem] flex items-center w-[16.1875rem] flex-shrink-0">
      {{ typeLabel() | transloco }}
    </label>
    <div class="w-[18rem] flex-shrink-0">
      <lib-select
        [inputFormControlName]="'resourceType'"
        [id]="'resourceType'"
        [name]="'resourceType'"
        [required]="false"
        [options]="resourceTypeOptions()"
        [selectedKeyName]="'label'"
        [selectedKeyValue]="'value'"
        [placeholder]="typePlaceholder() | transloco"
        [selectedOption]="selectedResourceTypeOption() || undefined"
        (changeOption)="onResourceTypeChange($event)" />
    </div>
    <button
      type="button"
      (click)="clearResourceType()"
      [disabled]="!filterForm().get('resourceType')?.value"
      class="flex items-center gap-x-sm text-base font-medium flex-shrink-0 transition-colors"
      [class.text-neutral-500]="filterForm().get('resourceType')?.value"
      [class.cursor-pointer]="filterForm().get('resourceType')?.value"
      [class.text-neutral-300]="!filterForm().get('resourceType')?.value"
      [class.cursor-not-allowed]="!filterForm().get('resourceType')?.value">
      <lib-reset-icon [width]="'20'" [height]="'20'" [iconClass]="'size-5'" />
      {{ 'filter_dropdown_reset' | transloco }}
    </button>
  </div>

  <!-- Assignee Row -->
  <div class="flex items-center gap-lg">
    <lib-drag-dots-icon
      [width]="'20'"
      [height]="'20'"
      [fill]="'#6B7280'"
      [iconClass]="'flex-shrink-0 cursor-move size-5'" />
    <label
      class="text-base font-medium text-neutral-700 border border-neutral-300 rounded-md px-md py-sm h-[2.75rem] flex items-center w-[16.1875rem] flex-shrink-0">
      {{ assigneeLabel() | transloco }}
    </label>
    <div class="w-[18rem] flex-shrink-0">
      @if (isMultiple()) {
        <lib-multi-select
          [id]="'assigneeId'"
          [inputFormControlName]="'assigneeId'"
          [name]="'assigneeId'"
          [options]="[]"
          [apiUrl]="assigneeDropdownConfig().api"
          [filters]="assigneeDropdownConfig().filters"
          [selectedKeyName]="'label'"
          [selectedKeyValue]="'value'"
          [initialSelectedOptions]="selectedAssigneeOptions()"
          [placeholder]="assigneePlaceholder() | transloco"
          [title]="assigneeLabel() | transloco"
          [disabled]="!filterForm().get('resourceType')?.value"
          (changeOption)="onAssigneeChange($event)" />
      } @else {
        <lib-paginated-select
          [id]="'assigneeSingleId'"
          [inputFormControlName]="'assigneeSingleId'"
          [name]="'assigneeSingleId'"
          [apiUrl]="assigneeDropdownConfig().api"
          [filters]="assigneeDropdownConfig().filters"
          [selectedKeyName]="'label'"
          [selectedKeyValue]="'value'"
          [selectedOption]="selectedSingleAssigneeOption()"
          [placeholder]="assigneePlaceholder() | transloco"
          [disabled]="!filterForm().get('resourceType')?.value"
          (changeOption)="onSingleAssigneeChange($event)" />
      }
    </div>
    <button
      type="button"
      (click)="clearAssignee()"
      [disabled]="!filterForm().get('assigneeId')?.value?.length"
      class="flex items-center gap-x-sm text-base font-medium flex-shrink-0 transition-colors"
      [class.text-neutral-500]="filterForm().get('assigneeId')?.value?.length"
      [class.cursor-pointer]="filterForm().get('assigneeId')?.value?.length"
      [class.text-neutral-300]="!filterForm().get('assigneeId')?.value?.length"
      [class.cursor-not-allowed]="
        !filterForm().get('assigneeId')?.value?.length
      ">
      <lib-reset-icon [width]="'20'" [height]="'20'" [iconClass]="'size-5'" />
      {{ 'filter_dropdown_reset' | transloco }}
    </button>
  </div>
</form>
